import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import ProbeTable from "@/components/probe/probeTable";

const ProbeList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_probe">
      <ProbeTable />
    </RestrictedPage>
  );
};

export default ProbeList;
